import { Colors, RainBow } from "../components/design-tokens/colors";

interface PerformanceByCasesInput {
  countryName?: string;
  latest: {
    averageNewCases: number;
    totalCases?: number | null;
  };
  data: {
    averageNewCases: number;
    infectionRate?: number | null;
  }[];
}

export const getPerformanceByCases = ({
  countryName,
  latest,
  data,
}: PerformanceByCasesInput) => {
  const { averageNewCases, totalCases } = latest;
  const last14InfectionRate = data
    ? data
        .slice(data.length - 14, data.length)
        .reduce((t, d) => (t += d.infectionRate || 1), 0) / 14
    : 1;
  const peak = Math.max(...data.map((d) => d.averageNewCases));

  let performance: string | undefined;
  let color: string = Colors.Pink;

  if (totalCases) {
    if (averageNewCases <= 20 && averageNewCases / totalCases < 0.02) {
      performance = "doing well";
      color = RainBow.GrassGreen;
    } else if (
      (last14InfectionRate < 0.95 || averageNewCases / totalCases < 0.01) &&
      averageNewCases < 1000 &&
      averageNewCases < peak * 0.5
    ) {
      performance = "getting there";
      color = Colors.Orange;
    } else {
      performance = "not doing well";
      color = Colors.Red;
    }
  }

  if (countryName === "Sweden") {
    performance = "not doing well";
    color = Colors.Red;
  }

  return { performance, color };
};

interface CountryPerformanceInput {
  countryName: string;
  data?:
    | {
        averageNewCases: number;
        totalCases: number | null;
        infectionRate?: number | null;
      }[]
    | null;
}

export const getCountryPerformance = ({
  countryName,
  data,
}: CountryPerformanceInput) => {
  if (!data || data.length === 0) {
    return { performance: undefined, color: undefined };
  }

  const latest = data[data.length - 1];

  return getPerformanceByCases({ countryName, latest, data });
};
